import $ from 'jquery';

function Banner(element, context) {
  this.$element = $(element);
  this.$body = this.getBody(context);
  this.init();
  this.ready();
}

Banner.prototype = {
  getBody(context) {
    return $(document.body, context);
  },
  init() {
    const hasBanner = this.$element.is('.banner:not(.placeholder-block)');
    if (hasBanner) {
      this.$body.addClass('has-banner');
    } else {
      this.$body.addClass('no-banner');
    }
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Banner;
